import {getPMSClient} from '../..'
import {getPMSBaseUrl} from '../../services/apiService'
import {createFetchActions} from '../../services/createActions'
import {post} from '../../services/createAPICall'
import {getAllFilesQuery} from './BenchmarkWeightsQueries'

export const UPLOAD_BENCHMARK_WEIGHTS_FILE = createFetchActions('UPLOAD_BENCHMARK_WEIGHTS_FILE')
export const GET_ALL_UPLOADED_BENCHMARK_WEIGHTS_FILES = createFetchActions('GET_ALL_UPLOADED_BENCHMARK_WEIGHTS_FILES')

export const uploadBenchmarkWeightsFile = data => (dispatch: any) => {
	return dispatch(post(UPLOAD_BENCHMARK_WEIGHTS_FILE, `${getPMSBaseUrl()}/v1/benchmark-weights/upload`, data))
}

export function getAllFiles() {
	return function (dispatch) {
		dispatch({
			type: GET_ALL_UPLOADED_BENCHMARK_WEIGHTS_FILES.triggered,
		})

		getPMSClient()
			.query({
				query: getAllFilesQuery,
				fetchPolicy: 'network-only',
			})
			.then(response => {
				dispatch({
					type: GET_ALL_UPLOADED_BENCHMARK_WEIGHTS_FILES.succeeded,
					response,
				})
			})
	}
}
